import { Typography } from 'components'

import { TrendingCard } from './TrendingCard'

const TrendingSection = () => (
	<section>
		<Typography
			class='mb-5'
			color='text-black-100'
			text='Trending'
			variant='h4'
		/>
		<div class='space-y-2'>
			<TrendingCard />
		</div>
	</section>
)

export { TrendingSection }
